import React, { useState } from 'react';
import { Grid, Typography, Box, Button, TextField, Collapse, useTheme } from '@mui/material';
import { tokens } from '../../../theme';
import { useUpdateWhitelabelConfigMutation } from '../../../features/organizations/organizationsApiSlice';

const WhitelabelDomains = ({ whitelabelConfig, organization }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [expanded, setExpanded] = useState(false);
  const [newDomain, setNewDomain] = useState({ host: '' });
  const [domains, setDomains] = useState([...whitelabelConfig]);
  const [updateWhitelabelConfig] = useUpdateWhitelabelConfigMutation();
  const organization_id = organization.organization_id;

  const handleChange = (e) => {
    setNewDomain({ ...newDomain, [e.target.name]: e.target.value });
  };

  const handleAddDomain = () => {
    setDomains([...domains, newDomain]);
    setNewDomain({ host: '' });
  };

  const handleSaveDomains = async () => {
    const whitelabel_config = domains.map(domain => ({
      host: domain.host,
      type: '',
      value: '',
      purpose: 'whitelabel'
    }));
    try {
      await updateWhitelabelConfig({ id: organization_id, whitelabel_config }).unwrap();
      setExpanded(false);
    } catch (error) {
      console.error('Failed to save whitelabel config:', error);
    }
  };

  return (
    <Box p={2}>
      <Typography variant="h4" style={{ fontWeight: 'bold', color: colors.primary[100], marginBottom: '16px' }}>
        Whitelabel Domains
      </Typography>
      {domains.map((config, index) => (
        <Box key={index} mb={2}>
          <Typography variant="body1">
            <Box component="span" fontWeight="bold">Host:</Box> {config.host || 'Not configured'}
          </Typography>
        </Box>
      ))}
      <Button
        variant="contained"
        color="primary"
        onClick={() => setExpanded(!expanded)}
        style={{ marginBottom: '16px' }}
      >
        {expanded ? 'Cancel' : 'Add New Domain'}
      </Button>
      <Collapse in={expanded}>
        <Box mb={2}>
          <Typography variant="h6">Add New Domain</Typography>
          <Box display="flex" flexDirection="column" mt={2}>
            <TextField
              fullWidth
              variant="filled"
              type="text"
              label="Host"
              name="host"
              value={newDomain.host}
              onChange={handleChange}
              style={{ marginBottom: '8px' }}
            />
            <Button
              variant="contained"
              color="secondary"
              onClick={handleAddDomain}
              style={{ alignSelf: 'flex-start', marginTop: '8px' }}
            >
              Add Domain
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSaveDomains}
              style={{ alignSelf: 'flex-start', marginTop: '8px' }}
            >
              Save Domains
            </Button>
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
}

export default WhitelabelDomains;
